import { get, post, put, del } from '../../api-config';
import { gdpService } from './_service';

export const postRelatives = async (data: any) =>
  await post(gdpService, '/relatives/search', data, null);

export const postNewRelative = async (data: any) =>
  await post(gdpService, '/relatives', data, null);

export const getRelative = async (id: any) =>
  await get(gdpService, `/relatives/${id}`, null, null);

export const getRelativeActions = (data: any) =>
  get(gdpService, `/patients/${data.id}/actions`, null, { init: data.init, size: data.size });

export const getRelativeRelatives = (data: any) =>
  get(gdpService, `/patients/${data.id}/relations`, null, {
    accesses: data.accesses,
    init: data.init,
    size: data.size,
  });

export const putRelativeInfo = (id: any, data: any) =>
  put(gdpService, `/relatives/${id}`, data, null);

export const deleteRelativeRelatives = (data: any) =>
  del(gdpService, `/patients/${data.userId}/relations/${data.relationId}`);
